"use client";
import { createContext } from "react";
const TrackingContext = createContext(void 0);
export {
  TrackingContext
};
